module.exports = __webpack_public_path__ + "assets/d59209cee21fc8a58dfb1bcb419696e6.png";